<app-last-events-card [myEvents]="myEvents$ | async"></app-last-events-card>
